module.exports = __webpack_public_path__ + "img/peaky-blinders.e6d6354a.jpg";